import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';

import {
  BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES,
  setRemoveSuperBatchesModalStage,
} from 'features/classCreation';
import styles from './RemoveSuperBatchesButton.module.scss';

export default function RemoveSuperBatchesButton({ disabled }) {
  const dispatch = useDispatch();

  const handleRemove = useCallback(() => {
    dispatch(
      setRemoveSuperBatchesModalStage(
        BULK_REMOVE_SUPER_BATCHES_MODAL_STAGES.info
      )
    );
  }, [dispatch]);

  return (
    <Tappable
      className={classNames('btn btn-outlined m-r-xs ', {
        'btn-primary': !disabled,
        [styles.removeBatchesButton]: disabled,
      })}
      onClick={handleRemove}
      disabled={disabled}
    >
      <Icon
        name="minus-circle"
        className="m-r-xxs"
      />
      Remove Batch/es
    </Tappable>
  );
}
